/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-14 16:10:20
 */
import liveHeaderBg from "@root/img/live_header_bg.png";
import liveDefault from "@root/img/live_default.png";
import contract from "@root/img/contace.png";
import liveMeeting from "@root/img/live_meeting.png";
import "./index.scss";
import { linkToCClive } from "@root/common/service";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
const liveRoomData = [
  {
    name: "直播回放",
    roomId: "EFE719CC5A1EE5049C33DC5901307461",
    ccUserId: "D71B0368E20B4CF5",
  },
];
export default function Live20231010pm() {
  const navigate = useNavigate();
  return (
    <div>
      <div className="live_header">
        <img src={liveHeaderBg} alt="" width={"100%"} height={"252px"} />
        <div className="content">
          <p>县域肿瘤防治中心建设指南发布会</p>
          <p>全&nbsp;程&nbsp;回&nbsp;放</p>
        </div>
      </div>
      <div className="live_main">
        <div className="live_default_entry">
          {liveRoomData.map((item) => (
            <div
              className="play_default_box"
              onClick={async () => {
                const { roomId, ccUserId } = item;
                const { data } = await linkToCClive(roomId, ccUserId);
                if (data === "未登录，请登录后再试") {
                  navigate("/home/index");
                  message.info(data);
                } else {
                  window.location.href = data;
                }
              }}
            >
              <img src={liveDefault} alt="" />
              <p>{item.name}</p>
            </div>
          ))}
        </div>
        <div className="live_content">
          <div className="content">
            <p className="title">
              <img src={contract} alt="" />
              <h3>联系人</h3>
            </p>
            <p>技术支持</p>
            <p>刘颜格 13810331953</p>
            <p>荆慧铭 13910899765</p>
          </div>
          <div className="content pad">
            <p className="title">
              <img src={liveMeeting} alt="" />
              <h3>会议日程</h3>
            </p>
            <p className="spot">
              2023年10月13日 13:00-17:00 线下地点：北京·新世纪日航酒店
            </p>
            <div className="timeline-list">
              <div className="timeline-item">
                <p className="time">13:00-13:02</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>主席开场</span>
                    <span>马飞 国家癌症中心</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">13:02-13:05</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>嘉宾致辞</span>
                    <span>国家卫生健康委卫生发展研究中心领导</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">13:05-13:08</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>嘉宾致辞</span>
                    <span>肿痛防治中心指南专家组</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">13:08-13:35</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>“千县工程”肿瘤防治中心指南解读</span>
                    <span>黄二丹 国家卫生健康委卫生发展研究中心</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">13:35-14:00</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>肺癌质控标准解读及规范化诊疗之路</span>
                    <span>谭锋维 中国医学科学院肿瘤医院</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">14:00-14:25</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>乳腺癌质控标准解读及规范化诊疗之路</span>
                    <span>李俏 国家癌症中心</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">14:25-14:50</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>MDT 建设促进规范化诊疗</span>
                    <span>段建春 国家癌症中心</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">14:50-15:15</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>科学化合理用药的意义与不良反应管理</span>
                    <span>梁莉 北京大学第三医院</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">15:15-15:40</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>肿瘤患者慢病全流程管理</span>
                    <span>卓明磊 北京大学肿瘤医院</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">15:40-16:05</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>肿瘤防治中心建设优秀案例分享</span>
                    <span>周明亮 浏阳市人民医院</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">16:05-16:45</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>圆桌讨论:</span>
                    <span>1、如何推动医联体下的省级肿瘤防治中心建设?</span>
                    <span>
                      2、如何发挥区域癌症中心管理协同作用，有效促进县域肿瘤防治体系建设与运营?
                    </span>
                    <span>(主持) 黄二丹 国家卫生健康委卫生发展研究中心</span>
                    <span>(主持) 张勤 江苏省肿瘤医院</span>
                    <span>洪涛 福建省卫健委</span>
                    <span>谭成森 山东省卫健委</span>
                    <span>马玉龙 安徽省医政医管处</span>
                    <span>代建军 山东省金乡县人民医院</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">16:45-16:50</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>会议总结</span>
                    <span>黄二丹 国家卫生健康委卫生发展研究中心</span>
                    <span>马飞 国家癌症中心</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
